import { render, staticRenderFns } from "./nskMaterialForm.vue?vue&type=template&id=72f1277e&scoped=true&"
import script from "./nskMaterialForm.vue?vue&type=script&lang=js&"
export * from "./nskMaterialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f1277e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f1277e')) {
      api.createRecord('72f1277e', component.options)
    } else {
      api.reload('72f1277e', component.options)
    }
    module.hot.accept("./nskMaterialForm.vue?vue&type=template&id=72f1277e&scoped=true&", function () {
      api.rerender('72f1277e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/incomingInspectionMgr/nskMaterialMgr/components/nskMaterialForm.vue"
export default component.exports